import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Typography } from '@mui/material';

export const Text = ({
  float = false,
  centered = false,
  ...props
}) => (
  <StyledText
    {...props}
    float={float ? 1 : 0}
    centered={centered ? 1 : 0}
  />
);

Text.propTypes = {
  float: PropTypes.bool,
  centered: PropTypes.bool
};

export const StyledText = styled(Typography)`
  float: ${({ float }) => float ? 'left' : 'none' };
  text-align: ${({ centered }) => centered ? 'center !important' : 'left' };
`;